/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignFileToCampaignCommand } from '../../models/assign-file-to-campaign-command';

export interface ApiCampaignsCampaignIdAssignFilePost$Params {
  campaignId: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: AssignFileToCampaignCommand
}

export function apiCampaignsCampaignIdAssignFilePost(http: HttpClient, rootUrl: string, params: ApiCampaignsCampaignIdAssignFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiCampaignsCampaignIdAssignFilePost.PATH, 'post');
  if (params) {
    rb.path('campaignId', params.campaignId, {});
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiCampaignsCampaignIdAssignFilePost.PATH = '/api/campaigns/{campaignId}/assign-file';
